<template>
    <v-text-field
        :disabled="readOnly"
        class="ucFirst body-2"
        :class="readOnly ? 'mb-2' : ''"
        :aria-label="formattedAriaLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :label="formattedLabel(
            metadata[`description${this.upperLocale}`],
            required
        )"
        :outlined="outlined"
        :append-icon="appendIcon"
        :value="value"
        :name="metadata.name"
        :color="$vuetify.theme.primary"
        :background-color="$vuetify.theme.primary"
        :placeholder="placeholder"
        :hint="readOnly ? formatHintText() : ''"
        :persistent-hint="readOnly"
        type="number"
        :min="minimumTraveler"
        :max="maximumTraveler"
        :rules="[
            !required || requiredField(),
            v => !v || v <= maximumTraveler || formatErrorText(),
            v => !v || v >= minimumTraveler || formatErrorText()
        ]"
        :data-meta-id="metadata.id"
        :id="metadata.name"
        @input="debouncedInput"
    />
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { ServiceSettings } from '@/enums';
import { debounce, find } from 'lodash';

export default {
    name: 'travel-traveler-count',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: [Number, String], required: false, default: null },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    data() {
        return {
            debouncedInput: undefined,
        };
    },
    created() {
        this.debouncedInput = debounce(this.emitValue, 500);
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            currentEstSettings: 'services/getCurrentEstSettings',
        }),

        appendIcon() {
            return this.withIcon ? 'fas fa-users' : '';
        },
        minimumTraveler() {
            const setting = find(this.currentEstSettings, ['setting', ServiceSettings.TRAVEL_MIN_TRAVELER_COUNT]);
            return setting.value;
        },
        maximumTraveler() {
            const setting = find(this.currentEstSettings, ['setting', ServiceSettings.TRAVEL_MAX_TRAVELER_COUNT]);
            return setting.value;
        },
        readOnly() {
            if (this.minimumTraveler === this.maximumTraveler) {
                this.emitValue(this.minimumTraveler);
                return true;
            }
            return false;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },

        formatErrorText() {
            return this.$i18n.t('appt.errors.travelerCount')
                .replace('%min%', this.minimumTraveler)
                .replace('%max%', this.maximumTraveler);
        },

        formatHintText() {
            return this.$i18n.t('form.travelerCountHint').replace('%traveler%', this.minimumTraveler);
        },
    },
};
</script>
